export default __webpack_public_path__ + "assets/images/ohrapuuro-ac5cfcfcdcc7790329a54385f9e0eb38.png";